<template>
    <v-row>
      <v-col cols="12">
          <sale-per-year-card> </sale-per-year-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import SalePerYearCard from "@/components/report/SalePerYearCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Sales Per Year",
    },
  
    components: {
       SalePerYearCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>